import React, { useState } from 'react';

import ForgotPasswordForm from './ForgotPasswordForm';
import ForgotPasswordConfirmation from './ForgotPasswordConfirmation';

import pic from '../../assets/loginpage-img-light.png';
import titleLogo_light from '../../assets/login-logo-light.svg';
import titleLogo_dark from '../../assets/login-logo-dark.svg';

import PropTypes from 'prop-types';
import ThemeTopSwitcher from '../ThemeTopSwitcher/ThemeTopSwitcher';
// import { useSelector } from 'react-redux';
// import Loading from '../Loading';

const ForgotPassword = ({ theme, setTheme }) => {
  // const isLoading = useSelector(state => state.userReducer.isLoading);
  const [nextStep, setNextStep] = useState(false);
  const [mail, setMail] = useState('');

  const renderComponent = () =>
    !nextStep ? (
      <ForgotPasswordForm
        setStep={setNextStep}
        setMail={setMail}
        theme={theme}
      />
    ) : (
      <ForgotPasswordConfirmation mail={mail} />
    );

  const handleThemeToggler = () => {
    const newTheme = theme === 'dark-theme' ? 'light-theme' : 'dark-theme';
    setTheme(newTheme);
  };

  return (
    <div className="login-wrapper">
      <div className="theme-switcher-wrapper">
        <ThemeTopSwitcher
          text={['DARK', 'LIGHT']}
          switcher={theme === 'dark-theme' ? 0 : 1}
          handleClick={handleThemeToggler}
        />
      </div>
      <div className="login-picture">
        <img src={pic} alt="login-picture" />
      </div>
      <div className="login-form">
        <div className="login-form-title">
          <img
            src={theme !== 'dark-theme' ? titleLogo_light : titleLogo_dark}
            alt="title logo"
          />
        </div>
        {renderComponent()}
      </div>
    </div>
  );
};

export default ForgotPassword;

ForgotPassword.propTypes = {
  theme: PropTypes.string,
  setTheme: PropTypes.func,
};
